export default "__VITE_ASSET__f19369cb__"